module.exports = __webpack_public_path__ + "d7c260585415c3675df8f11ed1eb192e.svg";